<template>
  <v-navigation-drawer app fixed :clipped="$vuetify.breakpoint.mdAndUp" v-model="leftBar" width="250"
    mobile-break-point="768">
    <v-list dense>
      <template v-for="item in menu">
        <!-- Header -->
        <v-layout row v-if="item.Type == 'Header'" align-center :key="item.Text">
          <v-flex xs12>
            <v-subheader style="color: black">{{ item.Text }}</v-subheader>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>

        <!-- Item -->

        <v-list-tile v-if="item.Type == 'Item'" :key="item.Text" @click="gotoPage(item)" :style="{
    borderLeft: checkLink(item)
      ? '4px solid #212121'
      : '4px solid #FFF',
    backgroundColor: checkLink(item) ? '#F5F5F5' : 'white',
  }">
          <v-list-tile-action>
            <img v-if="item.Image.endsWith('.png')" :src="getImg(item.Image)" style="width: 30px; height: 30px" />
            <v-icon v-else>{{ item.Image }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.Text }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="item.Novita">
            <v-chip color="red darken-1" text-color="white">New</v-chip>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { get_statoMenu } from "@/api/api.user.js";
import { get_ext_page } from "@/api/api.auth.js"

export default {
  props: {
    role: { type: String, default: "" },
    menu: null,
  },

  data: () => ({}),

  methods: {
    async gotoPage(item) {
      let res = await get_statoMenu(item.Id);
      if (res.data == undefined) return;
      if (res.data.toLowerCase() == "false" && this.role != "Admin") {
        this.$toast.warning(
          "Pagina in manutenzione. Riprova in un altro momento"
        );
        return;
      }
      if (item.Link == "@esci") {
        this.esci();
        return;
      }

      if (item.Link == "download") {
        let res = await get_ext_page("download");
        setTimeout(() => {
          window.open(res.data, '_blank');
        })
        return;
      }

      if (item.Link == "download_admin") {
        let res = await get_ext_page("admin");
        setTimeout(() => {
          window.open(res.data, '_blank');
        })
        return;
      }
      if (item.Link == "configuratore_agente") {
        let res = await get_ext_page("configuratore");
        setTimeout(() => {
          window.open(res.data, '_blank');
        })
        return;
      }

      if (item.Link == "offerte_cliente") {
        let res = await get_ext_page("offerte");
        setTimeout(() => {
          window.open(res.data, '_blank');
        })
        return;
      }

      if (item.Link.includes("dialog") == false)
        this.$store.commit("app/SET_MENUACTIVE", item.Text);

      this.$router.push({
        path: item.Link,
      });
    },

    esci() {
      this.$emit("esci");
    },

    checkLink(item) {
      return item.Link.replace("/", "") === this.$route.path.replace("/", "");
    },

    getImg(img) {
      return this.$load.getUrlImg() + "/menu/" + img;
    },
  },

  computed: {
    leftBar: {
      get: function () {
        return this.$store.getters["app/getLeftBar"];
      },
      set: function (val) {
        this.$store.commit("app/SET_LEFTBAR", val);
      },
    },
  },
};
</script>
